"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.camelToDashed = function (camel) {
    var outStr = "";
    for (var _i = 0, _a = camel.split(""); _i < _a.length; _i++) {
        var char = _a[_i];
        if (char.toUpperCase() === char) {
            outStr += "-" + char.toLowerCase();
        }
        else {
            outStr += char;
        }
    }
    return outStr;
};
